export default "__VITE_ASSET__11d79d0c__"